import { useCallback } from 'react'

import { TabSwitch } from '@circlefin/components'
import useTranslation from 'next-translate/useTranslation'

import { InformationVariants } from '../../../Information/Information.types'
import { useLinkBankAccount } from '../../../Link.Context'
import { NonIbanWireForm, PixForm } from '../../Forms'

export const BrazilVariant: React.FC = () => {
  const { t } = useTranslation('modals.bankAccount')
  const [, { setAccountVariant }] = useLinkBankAccount()

  const handleTabSwitch = useCallback(
    (tab: string) => {
      switch (tab) {
        case 'wire':
          setAccountVariant(InformationVariants.NON_IBAN)
          break
        case 'pix':
          setAccountVariant(InformationVariants.PIX)
          break
        default:
          throw new Error(`Missing type for tab ${tab}.`)
      }
    },
    [setAccountVariant],
  )

  return (
    <TabSwitch onChange={handleTabSwitch} selected="pix">
      <TabSwitch.Tabs variant="underlined-black">
        <TabSwitch.Tab id="pix">
          <div className="w-76">
            <p className="text-center text-neutral-strong font-circular-bold type-body-base">
              {t('link.accountInformation.type.pix')}
            </p>
            <p className="text-center text-neutral-subtlest type-body-sm">
              {t('link.accountInformation.description.instant')}
            </p>
          </div>
        </TabSwitch.Tab>
        <TabSwitch.Tab id="wire">
          <div className="w-76">
            <p className="text-center text-neutral-strong font-circular-bold type-body-base">
              {t('link.accountInformation.type.wire')}
            </p>
            <p className="text-center text-neutral-subtlest type-body-sm">
              {t('link.accountInformation.description.wire')}
            </p>
          </div>
        </TabSwitch.Tab>
      </TabSwitch.Tabs>

      <div className="mt-6">
        <TabSwitch.Content id="pix">
          <PixForm />
        </TabSwitch.Content>
        <TabSwitch.Content id="wire">
          <NonIbanWireForm />
        </TabSwitch.Content>
      </div>
    </TabSwitch>
  )
}
